var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.era.isEmpty())?_c('q-chip',{attrs:{"square":"","color":_vm.era.isActive()? 'positive': _vm.era.isUpcoming()? 'info': 'warning',"small":!_vm.dense,"dense":_vm.dense}},[_vm._v(" "+_vm._s(_vm.eraStatus)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }